<template>
<div class="datepicker reo-datepicker" ref="datepicker" @mouseover="mouseover" @mouseout="mouseout">
    <span :class="['current', {'hover': showArea}]">
        {{dateRender}}<span class="ui-icon icon-icon_down-2"></span>
        <i class="border-gradient ui-gradient-blue"></i>
    </span>
    <div class="select-area" v-show="showArea" :style="{'left': `${left}px`, 'width': `${areaWidth}px`}">
        <div class="select-area-main">
            <i class="border-gradient ui-gradient-blue"></i>
            <div class="area-header">
                <span>{{$t('datepicker.header.year')}}</span>
                <span>{{$t('datepicker.header.month')}}</span>
                <span>{{$t('datepicker.header.day')}}</span>
            </div>
            <div class="datepicker-gap"></div>
            <div class="area-content">
                <vue-scrollbar ref="year" class="datepicker-year datepicker-scroll">
                    <ul class="date-list">
                        <li v-for="(y, index) in availableyear" :key="index" @click="selectDate(y, index, 'year')" :class="{'selected': y === year}">{{y}}</li>
                    </ul>
                </vue-scrollbar>
                <vue-scrollbar ref="month" class="datepicker-month datepicker-scroll">
                    <ul class="date-list">
                        <li v-for="(m, index) in monthList" :key="index" @click="selectDate(m, index, 'month')" :class="{'not-available': !(availablemonth.includes(m) || m === 'All'), 'selected': m === month}">{{m}}</li>
                    </ul>
                </vue-scrollbar>
                <vue-scrollbar ref="day" class="datepicker-day datepicker-scroll">
                    <ul class="date-list">
                        <li v-for="(d, index) in dayList" :key="index" @click="selectDate(d, index, 'day')" :class="{'not-available': !(availableday.includes(d) || d === 'All'), 'selected': d === day}">{{d}}</li>
                    </ul>
                </vue-scrollbar>
                <!-- <div class="date-content-shadow"></div> -->
            </div>
            <hour
            :startTime="startHour"
            :endTime="endHour"
            @changeHandle="changeHandle"
            v-if="day !== '' && day !== 'All'"></hour>
            <div class="area-bottom">
                <button class="ui-button empty-button short-button comfirm-button" @click="comfirm">{{$t('datepicker.confirm')}}</button>
            </div>
        </div>
    </div>
    <div class="datepicker-shadow-area" v-show="showArea && clientWidth < 1200" :style="{
        'top': `0px`
    }" @click="showArea = false"></div>
</div>
</template>

<script>
import VueScrollbar from 'vue2-scrollbar';
import moment from 'moment';
import { resolve2, quickSort, isMobile } from '@/common/js/utils';
import hour from '@/basic/hour';
require( 'vue2-scrollbar/dist/style/vue2-scrollbar.css' );
export default {

    mounted () {

        $( '.datepicker-shadow-area' ).on({
            'touchmove' ( e ) {
                
                e.preventDefault();

            }
        });
        this.globalClick( this.globalClickHandle );
        window.addEventListener( 'resize', this.resizeHandle );
        this.calStyle();
        $( 'body' ).addClass( 'datepicker-show' );

    },

    destroyed () {

        window.removeEventListener( 'resize', this.resizeHandle );
        $( 'body' ).removeClass( 'datepicker-show' );

    },

    components: {

        VueScrollbar,
        hour

    },

    props: {

        value: {

            type: String,
            default () {

                return '';

            }

        },
        available: {

            type: Array,
            default () {

                return [];

            }

        }

    },
    data () {

        let monthList = [ 'All' ];
        let date = this.value || 'All-All-All';
        let year = '';
        let month = '';
        let day = '';
        let startHour = 0;
        let endHour = 24;
        if ( date ) {

            let arr = date.split( '-' );
            year = arr[ 0 ] || '';
            month = arr[ 1 ] || '';
            day = arr[ 2 ] || '';
            startHour = arr[ 3 ] || 0;
            endHour = arr[ 4 ] || 24;

        }
        for ( let date = 1; date < 13; date++ ) {

            monthList.push( resolve2( date ));

        }

        return {

            date: this.value,
            showArea: false,
            clientWidth: document.body.clientWidth,
            left: 0,
            areaTop: 0,
            areaWidth: 0,
            areaRight: 434,
            listHeight: 50,
            monthList,
            scrollbar: {

                width: '33%',
                maxWidth: '180px',
                maxHeight: '300px',
                display: 'inline-block',
                'font-size': 0,
                'vertical-align': 'top'

            },
            year,
            month,
            day,
            startHour,
            endHour
            
        };

    },
    methods: {

        showContent ( e ) {

            if ( this.showArea ) {

                this.showArea = !this.showArea;

            } else {

                let title = $( e.target ).eq( 0 );
                let windowWidth = $( 'body' ).eq( 0 )[ 0 ].offsetWidth;
                // let parent = $( e.target ).parent( '.datepicker' );
                let titleWidth = title[ 0 ].offsetWidth;
                let titleLeft = title.offset().left;
                let titleRigth = windowWidth - titleWidth - titleLeft;
                // let titleTop = title.offsetTop;
                this.areaWidth = windowWidth > 434 ? 434 : windowWidth;
                let distance = ( titleWidth - this.areaWidth ) / 2;
                if ( titleLeft + distance < 0 ) {

                    this.areaLeft = -titleLeft;

                } else if ( titleRigth + distance < 0 ) {
                    
                    this.areaLeft = ( distance - titleRigth - titleWidth / 2 );

                } else {
                    
                    this.areaLeft = distance;

                }
                this.showArea = !this.showArea;
                // this.$nextTick(() => {

                //     this.scrollInit();

                // });

            }

        },
        comfirm () {

            this.showArea = false;
            this.date = `${this.year}${this.month ? `-${this.month}` : ``}${this.day ? `-${this.day}-${this.startHour}-${this.endHour}` : ``}`;
            this.$emit( 'input', this.date );

        },
        globalClickHandle ( e ) {

            let outSide = $( e.target ).parents( '.reo-datepicker' ).length === 0;
            if ( outSide && this.showArea ) {

                this.showArea = false;

            }

        },
        resolve2 ( num ) {

            return resolve2( num );

        },
        quickSort ( arr ) {

            return quickSort( arr );

        },
        selectDate ( value, index, type ) {

            if ( !this[`available${type}`].includes( value ) && value !== 'All' ) {

                return false;

            }
            if ( value === 'All' ) {

                if ( type === 'year' ) {

                    this.month = 'All';
                    this.day = 'All';

                }
                if ( type === 'month' ) {

                    this.day = 'All';

                }

            }
            this[ type ] = value;
            // this.$refs[ type ].scrollToY( index * 50 );

        },
        scrollInit () {

            let year = this.availableyear.indexOf( this.year );
            let month = this.availablemonth.indexOf( this.month ) + 1;
            let day = this.availableday.indexOf( this.day ) + 1;
            this.scrollToY( 'year', year );
            this.scrollToY( 'month', month );
            this.scrollToY( 'day', day );

        },
        dateInit () {

            let date = this.value || 'All-All-All';
            let arr = date.split( '-' );
            this.year = arr[ 0 ] || '';
            this.month = arr[ 1 ] || '';
            this.day = arr[ 2 ] || '';

        },
        resizeHandle () {

            this.clientWidth = document.body.clientWidth;
            this.calStyle();

        },
        calStyle () {

            let clientWidth = this.clientWidth;
            let content = $( this.$refs.datepicker );
            let title = content.find( '.current' );
            let titleLeft = title.offset().left;
            let titleTop = title.offset().top;
            let titleWidth = title[ 0 ].offsetWidth;
            let titleHeight = title[ 0 ].offsetHeight;
            // let areaLeft = area.offset().left;
            let areaWidth = clientWidth > 1199 ? 434 : clientWidth;
            let distance = ( areaWidth - titleWidth ) / 2;
            let left = 0;
            // Beyond the left of window
            if ( titleLeft - distance < 0 ) {

                left = -titleLeft;
            
            } else if ( titleLeft + distance + titleWidth > clientWidth ) {
                
                // Beyond the right of window
                left = -( areaWidth - ( clientWidth - titleLeft ));

            } else {

                left = -distance;

            }
            this.left = left;
            this.areaWidth = areaWidth;
            this.areaTop = titleTop + titleHeight;

        },
        mouseout ( e ) {
            
            if ( e.screenX !== 0 && e.screenY !== 0 ) {

                this.showArea = false;

            }

        },
        mouseover () {

            this.showArea = true;

        },
        scrollToY ( stage, index ) {

            let content = $( this.$refs.datepicker );
            let list = content.find( '.date-list li' );
            let height = list[ 0 ].clientHeight;
            this.$refs[ stage ].scrollToY( index * height );

        },
        changeHandle ( start, end ) {

            this.startHour = start;
            this.endHour = end;

        }

    },
    watch: {

        date ( date ) {

            this.$emit( 'input', date );

        },
        value ( value ) {

            this.date = value;
            let date = value || 'All-All-All';
            if ( date ) {

                let arr = date.split( '-' );
                this.year = arr[ 0 ] || 'All';
                this.month = arr[ 1 ] || 'All';
                this.day = arr[ 2 ] || 'All';
                this.startHour = Number( arr[ 3 ] ) || 0;
                this.endHour = Number( arr[ 4 ] ) || 24;

            }

        },
        year ( year ) {

            let index = this.availableyear.indexOf( year ) === -1 ? 0 : this.availableyear.indexOf( year );
            this.scrollToY( 'year', index );
            this.scrollToY( 'month', 0 );

        },
        month ( month ) {

            let index = this.monthList.indexOf( month ) === -1 ? 0 : this.availablemonth.indexOf( month ) + 1;
            this.scrollToY( 'month', index );
            this.scrollToY( 'day', 0 );

        },
        day ( day ) {

            let index = this.dayList.indexOf( day ) === -1 ? 0 : this.availableday.indexOf( day ) + 1;
            this.scrollToY( 'day', index );

        },
        showArea () {

            this.dateInit();
            if ( this.showArea ) {

                this.calStyle();
                $( 'html' ).css( 'overflow-y', 'hidden' );
                if ( !isMobile()) {

                    $( 'html' ).addClass( 'scroll-bar-hide' );
                
                }

            } else {

                $( 'html' ).css( 'overflow-y', 'auto' );
                $( 'html' ).removeClass( 'scroll-bar-hide' );

            }

        },
        available () {

            this.scrollToY( 'year', 0 );
            this.scrollToY( 'month', 0 );
            this.scrollToY( 'day', 0 );
            
        }

    },
    computed: {

        dayList () {

            let year = this.year;
            let month = this.month;
            let dayLength = 30;
            let dayList = [ 'All' ];
            if ( year !== 'All' && month !== 'All' ) {

                let thisMonth = moment( `${year} ${month} 01 00:00:00`, `YYYY MM DD 00:00:00` ).unix();
                let nextMonth = moment( `${year} ${month} 01 00:00:00`, `YYYY MM DD 00:00:00` ).add( 1, 'M' ).unix();
                dayLength = parseFloat(( nextMonth - thisMonth ) / 86400 );

            }
            for ( let day = 0; day < dayLength; day++ ) {

                dayList.push( resolve2( day + 1 ));

            }
            return dayList;

        },
        availableyear () {

            let available = this.available;
            let yearList = [];
            if ( available.length === 0 ) {

                return [ 'All' ];

            }
            for ( let date of available ) {

                let year = date.split( '-' )[ 0 ];
                if ( !yearList.includes( year )) {

                    yearList.push( year );

                }

            }
            yearList = quickSort( yearList );
            yearList.unshift( 'All' );
            return yearList;

        },
        availablemonth () {

            let available = this.available;
            let year = this.year;
            let monthList = [];
            if ( available.length !== 0 && year ) {

                for ( let date of available ) {

                    let arr = date.split( '-' );
                    if ( arr[ 0 ] === year && !monthList.includes( arr[ 1 ] )) {

                        monthList.push( arr[ 1 ] );

                    }

                }

            }
            return monthList;

        },
        availableday () {

            let available = this.available;
            let year = this.year;
            let month = this.month;
            let dayList = [];
            if ( available.length !== 0 && year && month ) {

                for ( let date of available ) {

                    let arr = date.split( '-' );
                    if ( arr[ 0 ] === year && arr[ 1 ] === month && !dayList.includes( arr[ 2 ] )) {

                        dayList.push( arr[ 2 ] );

                    }

                }

            }
            return dayList;

        },
        dateRender () {

            let date = this.date;
            let arr = date.split( '-' );
            let year = arr[ 0 ];
            let month = arr[ 1 ];
            let day = arr[ 2 ];
            if ( year === 'All' ) {

                return this.$t( 'datepicker.allTime' );

            }
            return `${year}${month === 'All' ? `` : `-${month}`}${day === 'All' ? `` : `-${day}`}`;

        }

    }

};
</script>

<style lang="less">
.area-header{
    height: 0.86rem;
}
.current.hover{
    color: @theme;
}
.current{
    font-size: 0.16rem;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
    line-height: .8rem;
    display: block;
}
.comfirm-button{
    width: 1.56rem;
}
.datepicker{
    display: inline-block;
    position: relative;
}
.select-area{
    width: 434px;
    position: absolute;
    z-index: 99;
    border-radius: 0 0 0.1rem 0.1rem;
    border: 1px solid #fff;
    box-sizing: border-box;
}
.select-area-main{
    background-color: #fff;
    box-shadow: 0px 1px 4px 0px #ccc;
    border-radius: 0 0 0.1rem 0.1rem;
}
.date-list{
    font-size: 0.16rem;
    padding-bottom: 2rem;
}
.datepicker-scroll{
    width: 33%;
    max-width: 180px;
    max-height: 2.5rem;
    display: inline-block;
    font-size: 0;
    vertical-align: top;
}
.datepicker-scroll+.datepicker-scroll{
    border-left: 1px solid #f3f4f5;
}
.date-list>li{
    height: .5rem;
    line-height: .5rem;
    color: #333;
    text-align: center;
    cursor: pointer;
    font-weight: 500;
    user-select: none;
}
.date-list>li:hover{
    background-color: #F7F7F7;
    color: @theme;
}
.area-content{
    background-color: #fff;
    position: relative;
    font-size: 0;
}
.area-header{
    font-size: 0;
}
.area-header>span{
    width: 33%;
    max-width: 180px;
    max-height: 300px;
    display: inline-block;
    text-align: center;
    font-size: 0.2rem;
    line-height: 0.84rem;
    font-weight: 500;
}
.vue-scrollbar__scrollbar-vertical{
    width: 0px !important;
    cursor: pointer;
}
.date-content-shadow {
    height: 50px;
    position: absolute;
    width: 100%;
    background: -webkit-linear-gradient(rgba(255,255,255,0.3) 30%,rgba(255,255,255,0.8) 100%);
    bottom: 0;
}
.date-list>li.not-available {
    display: none;
    cursor: not-allowed;
    color: #ccc;
    font-weight: 400;
}
.date-list>li.not-available:hover {
    background-color: #fff;
}
.date-list>li.selected {
    color: @theme;
}
.reo-datepicker .icon-icon_down-2{
    font-size: 0.12rem;
    margin-left: 0.1rem;
    position: relative;
    top: -0.02rem;
}
.reo-datepicker .area-bottom{
    padding: 0.2rem 0 0.34rem 0;
    text-align: center;
}
.datepicker-shadow-area{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0);
    z-index: 98;
    display: none;
}
.datepicker .current .ui-gradient-blue{
    display: none;
    position: absolute;
    bottom: 0;
    width: 100%;
}
.vue-scrollbar__scrollbar-horizontal .vue-scrollbar-transition{
    display: none;
}
@media screen and (max-width:1199px){
    .select-area{
        box-shadow: 0 0.16rem 0.6rem rgba(0,0,0,0.12);
    }
    .current{
        font-size: 0.26rem;
    }
    .comfirm-button{
        width: 2.15rem;
    }
    .area-header>span{
        font-size: 0.34rem;
    }
    .reo-datepicker .icon-icon_down-2{
        font-size: 0.15rem;
    }
    .datepicker-shadow-area{
        display: block;
    }
    .datepicker .select-area-main .ui-gradient-blue{
        display: none;
    }
    .datepicker .current.hover .ui-gradient-blue{
        display: block;
    }
    .reo-datepicker{
        width: 100%;
    }
    .date-list{
        font-size: 0.26rem;
        padding-bottom: 272px;
    }
    .date-list>li{
        line-height: 68px;
        height: 68px;
    }
    .datepicker-scroll{
        max-height: 340px;
    }
}
@media screen and (max-width:500px) {
    .date-list{
        padding-bottom: 140px;
    }
    .date-list>li{
        line-height: 35px;
        height: 35px;
    }
    .datepicker-scroll{
        max-height: 175px;
    }
}
.datepicker-gap{
    margin: 0 55px 0.2rem;
    border-top: 1px solid #eee;
    @media @mobile{
        margin: 0 15px 0.3rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/Datepicker.vue